import _remove from 'lodash/remove';

class Product {
  constructor(data){
    this.id = data.id;
    this.productGroupId = data.productGroupId;
    this.name = data.name;
    this.position = data.position;
    this.answerIds = data.answerIds;
  }

  static all(productGroupsData) {
    let products = [];

    for (let productGroupData of productGroupsData) {
      let data = productGroupData.products;

      for (let productData of data) {
        productData.productGroupId = productGroupData.id;
        products.push(new Product(productData))
      }
    }

    return products;
  }

  static hasIntersectionWithAnswerIds(product, answerIds) {
    let intersection = product.answerIds.filter(x => answerIds.includes(x)); // from https://medium.com/@alvaro.saburido/set-theory-for-arrays-in-es6-eb2f20a61848
    return (intersection && intersection.length);
  }

  static filter(allProducts, answeredQuestions) {
    let filteredProducts = allProducts;

    for (let question of answeredQuestions) {

      if (question.type == 'checkboxes') {
        if ((question.selectedAnswerIds !== undefined) && (question.selectedAnswerIds.length > 0)) {
          // we have some answers - we should filter by this question

          let clone = Array.from(filteredProducts);
          filteredProducts = _remove(clone, function(p) {
            return Product.hasIntersectionWithAnswerIds(p, question.selectedAnswerIds);
          });

        }
      }

      if (question.type == 'dropdown') {
        if (question.selectedAnswerId !== undefined) {
          let selectedAnswer = question.answers.find(a => a.id == question.selectedAnswerId);
          if (selectedAnswer !== undefined) {

            let clone = Array.from(filteredProducts);
            filteredProducts = _remove(clone, function(p) {
              return (p.answerIds.includes(selectedAnswer.id));
            });

          }
        }
      }

      if (question.type == 'slider') {
        if (question.selectedAnswers !== undefined) {

          let selectedAnswerObjects = question.answers.filter(a => ((Number(a.phrase) >= question.selectedAnswers[0]) &&
                                                                    (Number(a.phrase) <= question.selectedAnswers[1])));
          let selectedAnswerIds = selectedAnswerObjects.map(x => x.id);

          let clone = Array.from(filteredProducts);
          filteredProducts = _remove(clone, function(p) {
            return Product.hasIntersectionWithAnswerIds(p, selectedAnswerIds);
          });

        }
      }

      if (question.type == 'search') {
        if ((question.answer !== undefined) && (question.answer !== '')) {

          let clone = Array.from(filteredProducts);
          filteredProducts = _remove(clone, function(p) {
            return (p.name.toLowerCase() == question.answer.toLowerCase());
          });

        }
      }
    }

    return filteredProducts;
  }
}

export default Product;
